import { Link } from "@StarberryUtils";
import React, { useEffect, useState, useRef } from "react";
import { useStaticQuery, graphql } from "gatsby";
import { canDoPostLoginAction } from "@myaccountServices/store/utils"
import FsLightbox from 'fslightbox-react';
import { Col, Row, Container } from 'react-bootstrap';
import ModalTiny from "react-bootstrap/Modal"
import axios from 'axios';
import "./Booking.scss";
// import propertyImg01 from "../../../images/property-img01.jpg"
// import propertyImg02 from "../../../images/property-img02.jpg"
// import propertyImg03 from "../../../images/property-img03.jpg"
// import profileIcn4 from "../../../images/profile-img04.png"
import Prev from "../../../images/left-arrow.png"
import Next from "../../../images/right-arrow.png"
// import AliceCarousel from 'react-alice-carousel';
import "react-alice-carousel/lib/alice-carousel.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
// import { Carousel } from 'react-responsive-carousel';
import { navigate } from "@reach/router"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
// import {Image }from './Image'
// import VideoPlay from "../../Play/property-results-video";
import PropertyDetailsModal from "../../Play/property-details-video-modal"
import PropertyDetailsModalIconVideo from "../../Play/property-details-video-modal-icon"
import Form from "../../forms/book-a-viewing-form"
import AskForm from "../../forms/ask-question-form"
import SendForm from "../../forms/send-friend-form"
import Negotiator from "./negotiator"
import "../FixedButtons/FixedButtons.scss";
import NoImg from "../../../images/no-image.png"
import $ from "jquery";
import FloorPlanModalDetails from "../../../components/property-search/floorPlanModalDetails";
import FloorPlanModalDetailsNewHomes from "../../../components/property-search/floorPlanModalDetailsNewHomes";
import ImageTransform from "../../common/ggfx-client/module/components/image-transform";
import SaveProperty from "../SaveProperty";
import SocialShare from "../../utils/socialShare";

// import "slick-carousel/slick/slick-theme.css"

import { inViewOptions } from '../../../components/utils/animations';
import { motion } from "framer-motion";
import { InView } from "react-intersection-observer";
import { SliderPrevArrow, SliderNextArrow } from "../../../icons/icons";
import {ValuationEmailMatch} from '../../forms/valuation-email-matching'
import { OfficeEmailMatch } from "../../forms/office-email-matching";

const containerVariants = {
    hidden: {
        opacity: 0,
    },
    visible: {
        opacity: 1,
        transition: {
            ease: [0.33, 1, 0.68, 1],
            duration: 0.4
        }
    }
}
const containerItemImage = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: {
            ease: [0.33, 1, 0.68, 1],
            duration: 0.4
        }
    }
}
const containerItemText = {
    hidden: { opacity: 0, y: 40 },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            ease: [0.33, 1, 0.68, 1],
            duration: 0.6
        }
    }
}

function NextArrow(props) {
    const {
        // className,
        // style,
        onClick
    } = props;
    return (
        <a onClick={onClick} className="slick-next">
            <img loading="lazy" src={Next} alt="" />
        </a >
    );
}

function PrevArrow(props) {
    const {
        // className,
        // style,
        onClick
    } = props;
    return (
        <a onClick={onClick} className="slick-prev">
            <img loading="lazy" src={Prev} alt="" />
        </a >
    );
}

const strapiconfig = {
    headers: {
        Authorization:
            `Bearer ${process.env.GATSBY_STRAPI_FORM_TOKEN}`,
    },
  }

const Booking = (props, property_images) => {

  const data = useStaticQuery(graphql`
  query{
    strapidata {
        offices {
          URL
          Sales_CRM_ID
          New_Homes_CRM_ID
          Lettings_CRM_ID
          Email
          Secondary_Email
          Usearea_General
          Usearea_Lettings
          Usearea_Sales
        }
    }
  }
`);

  const allOfficesList = data?.strapidata?.offices

    const [toggler, setToggler] = useState(false);

    const [isOpen, setOpen] = useState(false);

    const [productIndex, setProductIndex] = useState(0);

    const slider = useRef(null)


    const [modalBookViewformOpen, setBookViewingformOpen] = React.useState(false);
    const openBookViewformModal = () => {
        setBookViewingformOpen(true);
    }
    const closeBookViewformModal = () => {
        setBookViewingformOpen(false);
    }


    const [modalSendfrndformOpen, setSendfrndformOpen] = React.useState(canDoPostLoginAction('bookaviewing') || false);
    const openSendfrndformModal = () => {
        setSendfrndformOpen(true);
    }
    const closeSendfrndformModal = () => {
        setSendfrndformOpen(false);
    }

    const [modalAskformOpen, setAskformOpen] = React.useState(false);
    const openAskformModal = () => {
        setAskformOpen(true);
    }
    const closeAskformModal = () => {
        setAskformOpen(false);
    }



    const [indexed, setIndex] = useState(1)

    const mainSlider = useRef(null);
    const thumbnailSlider = useRef(null);
    const [nav1, setNav1] = useState(null);
    const [nav2, setNav2] = useState(null);
    useEffect(() => {
        setNav1(mainSlider.current);
        setNav2(thumbnailSlider.current);
    }, []);
    
    const mainSettings = {
        dots: false,
        arrows: false,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        asNavFor: nav2,
      };
      const thumbnailCount = props?.property_images ? props?.property_images?.length : 0;
      const thumbnailSettings = {
        dots: false,
        arrows: false,
        speed: 1000,
        slidesToShow: 5,
        slidesToScroll: 1,
        infinite: thumbnailCount > 5,
        focusOnSelect: true,
        asNavFor: nav1,
      };

    const afterChangeHandler = (d) => {
        setIndex(d + 1)
    }
    const handleBack = () => {
        // if (window.history.length > 1) {
        window.history.back()
        // } else {
        // var historybackpath = location.pathname.split('/');
        // if (historybackpath[1] === "property-for-sale") {
        //     navigate(`/property/for-sale/in-london/include-sold/`);
        // } else if (historybackpath[1] === "property-to-rent") {
        //     navigate(`/property/to-rent/in-london/include-let/`);
        // } else if (historybackpath[1] === "commercial-property-for-sale") {
        //     navigate(`/property/commercial/for-sale/in-london/`);
        // } else if (historybackpath[1] === "commercial-property-to-rent") {
        //     navigate(`/property/commercial/to-rent/in-london/`);
        // } else if (historybackpath[1] === "new-homes-for-sale") {
        //     navigate(`/property/new-homes/for-sale/in-london/include-sold/`);
        // } else if (historybackpath[1] === "new-homes-to-rent") {
        //     navigate(`/property/new-homes/to-rent/in-london/include-let/`);
        // } else  {
        //     navigate(`/property/for-sale/in-london/include-sold/`);
        // }
        // }
    }

    // Office Fetch
    const [officeItems, setOfficeItems] = useState([])
    // const getitems = async url => {
    //     try {
    //         const { data } = await axios.get(url, strapiconfig)
    //         if (data && data.length > 0) {
    //             setOfficeItems(data)

    //             console.log("vvv111223", data)
    //         }
    //     } catch (error) {
    //         console.error(error)
    //     }
    // }
    // Office Fetch

   


    useEffect(() => {

        // let url = process.env.GATSBY_STRAPI_SRC + "/offices?_where[_or][0][Sales_CRM_ID]=" + props.office_id + "&_where[_or][1][Lettings_CRM_ID]=" + props.office_id + "&_where[_or][2][New_Homes_CRM_ID]=" + props.office_id;
        // getitems(url)

        allOfficesList.map((officedata, index) => {
            if((officedata.Sales_CRM_ID && officedata.Sales_CRM_ID == props.office_id) || (officedata.Lettings_CRM_ID && officedata.Lettings_CRM_ID == props.office_id) || (officedata.New_Homes_CRM_ID && officedata.New_Homes_CRM_ID == props.office_id)) {
                setOfficeItems(officedata)
            }
        })
    

        // Filter active onscroll
        $(window).scroll(function () {
            //var scroll = $(window).scrollTop();
            var mapdiv = $('#property-map');
            if (mapdiv.length) {
                if ($(this).scrollTop() >= mapdiv.offset().top + 100) {
                    $(".property_new_sticky").removeClass("active_sticky");
                }
                else {
                    $(".property_new_sticky").addClass("active_sticky");
                }
            }

        });
        // Filter active onscroll

        // New home fixed menu active state
        $('.property-newhomes-menu li a').click(function () {
            $(".property-newhomes-menu li a").removeClass("active");
            $(this).addClass('active');
        });
        // New home fixed menu active state

        // New home click to scroll
        $(".details_features").click(function () {
            $('html, body').animate({
                scrollTop: $("#detailsFeatures").offset().top - 200
            }, 1000);
        });

        $(".availability").click(function () {
            $('html, body').animate({
                scrollTop: $("#availability").offset().top - 200
            }, 1000);
        });

        //$(".new_homes_video").click(function() {
        //    $('html, body').animate({
        //        scrollTop: $("#new_homes_video").offset().top - 200
        //    }, 1000);
        //});

        $(".location").click(function () {
            if (props.maphandleChange) {
                props.maphandleChange("location");
            }
            $('html, body').animate({
                scrollTop: $("#propertymap").offset().top - 200
            }, 1000);
        });
        // New home click to scroll

        // School to scroll
        $(".mapTransportSchool").click(function () {
            if (props.maphandleChange) {
                props.maphandleChange("schools");
            }
            $('html, body').animate({
                scrollTop: $("#propertymap").offset().top - 100
            }, 1000);
        });
        // School to scroll

        // Transport to scroll
        $(".mapTransportTransport").click(function () {
            if (props.maphandleChange) {
                props.maphandleChange("location");
            }
            $('html, body').animate({
                scrollTop: $("#propertymap").offset().top - 100
            }, 1000);
        });
        // Transport to scroll

        // Scroll to map
        // let params = (new URL(document.location)).searchParams;
        // let property_mapid = params.get('id');
        // if(property_mapid) {

        //     $('html, body').animate({
        //         scrollTop: $("#map-holder").offset().top - 5
        //     }, 500);
        // }
        // Scroll to map
    }, []);

    // Share icons
    const shareurl = typeof window !== 'undefined' ? window.location.href : ''

    const [Shareicons, setShareicons] = React.useState(false);
    const openShareicons = () => {
        setShareicons(true);
        if (Shareicons === true) {
            setShareicons(false);
        }
    }
    // Share icons

    if (props.property_images.length > 0) {
        var img_1 = props.property_images[0].hd_url || props.property_images[0].srcUrl;
    } else {
        var img_1 = NoImg;
    }

    const lightImages2 = props.property_images && props.property_images.map(img => (img.hd_url || img.url));

    const imglength = lightImages2?.length;
    const [lightboxController, setLightboxController] = useState({
        toggler: false,
        slide: 1
    });

    const openLighbox = (e) => {
        e.preventDefault();
        setLightboxController({
            toggler: !lightboxController.toggler,
            slide: 1
        });
    }

    const openLighboxMobile = (e, ind) => {
        e.preventDefault();
        setLightboxController({
            toggler: !lightboxController.toggler,
            slide: ind
        });
    }

    var office_email = ''
    var office_type = ''
    var office_usearea_email = ''
    /*if (officeItems) {
        office_email = officeItems.Email  
        office_usearea_email = officeItems.Usearea_General
        if (officeItems.Sales_CRM_ID == props.office_id) {
            office_type = "Sales"
            office_usearea_email = '' // officeItems.Usearea_Sales
        }
        else if (officeItems.Lettings_CRM_ID == props.office_id) {
            office_type = "Lettings"
            office_usearea_email = officeItems.Usearea_Lettings
        }
        else if (officeItems.New_Homes_CRM_ID == props.office_id) {
            office_type = "New Homes"
            office_usearea_email = officeItems.Usearea_General
        }

        if(props.property_search_type == "lettings" && officeItems.URL == "crouch-end"){ 
            office_email = `mgcrouchend@mail.inspectrealestate.co.uk${officeItems?.Secondary_Email ? `, ${officeItems?.Secondary_Email}` : ''}`;
            office_usearea_email = ""
        }
        if(props.property_search_type == "lettings" && officeItems.URL == "kentish-town"){  
            office_email = `mgkentishtown@mail.inspectrealestate.co.uk${officeItems?.Secondary_Email ? `, ${officeItems?.Secondary_Email}` : ''}`;
            office_usearea_email = ""
        } 
    }*/

    var emailMatchingValues = { postcode: props?.property_fullpostcode || props.postcode }
    var emailIds = ValuationEmailMatch(emailMatchingValues);   
    if(emailIds){
        var uniq = [...new Set(emailIds)]
        office_email = [...uniq].toString(); 
    }
    if(props.isCommercial){
        office_email = "davids@martyngerrard.co.uk"
    }

    const { office_id } = props;
    const negotiatorEmail = OfficeEmailMatch(office_id);

    const { office_details } = props;
    const officeEmail = office_details?.Email || "HO@martyngerrard.co.uk";

   const keywords = props?.keywords?.some(k => k.toLowerCase() === "no deposit option available")


    // Image fallback logic
    const ImageRenderList = ({ imagesources, renderer, imagename, attr, imagetransformresult, id }) => {
        if (imagesources?.url) { return (  <ImageTransform imagesources={imagesources.url} renderer={renderer} imagename={imagename} attr={attr} imagetransformresult={imagetransformresult} id={id} /> ); }
        if (imagesources?.srcUrl) { return ( <img src={imagesources.srcUrl} alt={attr?.alt} loading="lazy" /> ); }
        return <img src={NoImg} alt="" />;
    };
    
    // virtual_tour holds up to two links, but the feed drops empty slots so position is not
    // reliable. Classify by domain instead: a Matterport link is the virtual tour, anything
    // else is the general video. Either can be absent, leaving a plain property image.
    const virtual_tour_list = (Array.isArray(props.property_video) ? props.property_video : [])
        .filter(url => typeof url === 'string' && url.trim())
        .map(url => url.trim())
        .filter((url, index, list) => list.indexOf(url) === index)
    const isMatterport = (url) => url.toLowerCase().indexOf("matterport.com") > -1
    const tour_links = virtual_tour_list.filter(url => isMatterport(url))
    const video_links = virtual_tour_list.filter(url => !isMatterport(url))
    const virtual_tour_url = tour_links[0] || ''
    const general_video_url = video_links[0] || ''
    // Left tile prefers the tour. With no tour but two videos it carries the first one,
    // badged "Video", so the second link still gets a place instead of being dropped.
    const tile_one_url = virtual_tour_url || (video_links.length > 1 ? video_links[0] : '')
    const tile_one_label = virtual_tour_url ? 'Virtual Tour' : 'Video'
    // Right tile always carries a video - the second one when the left tile took the first.
    const tile_two_url = virtual_tour_url ? general_video_url : (video_links[1] || general_video_url)
    
    return (
        <InView {...inViewOptions}>
            {({ ref, inView }) => (
                <>
                    <motion.section
                        className="property-booking d-xl-flex"
                        ref={ref}
                        initial="hidden"
                        animate={inView ? "visible" : "hidden"}
                        variants={containerVariants}
                    >
                        {
                            props.property_images ?
                                <motion.div
                                    className="booking-view order-xl-2"
                                    variants={containerItemImage}
                                >
                                    <div className="main-view">
                                    <div className="main-slider-wrap">
                                        <Slider {...mainSettings} ref={mainSlider} afterChange={
                                                v => afterChangeHandler(v)
                                            }>
                                        {props.property_images && props.property_images.map((img, index) => (
                                            <div key={index} className="slider-block-col">
                                            {img?.hd_url ? <img src={img?.hd_url} alt={`${props.property_title} - Martyn Gerrard`} /> :
                                            <ImageRenderList
                                                imagesources={img}
                                                renderer="srcSet"
                                                imagename="property.images.detail"
                                                attr={{ alt: `${props.property_title} - Martyn Gerrard`, class: '' }}
                                                imagetransformresult={props.processedImages}
                                                id={props.id}
                                            /> }
                                            </div>
                                        ))}
                                        {props.property_images.length === 0 && <img loading="lazy" src={NoImg} alt="" />}
                                        </Slider>
                                        <div className="main-navigation">
                                        <button className="prev" onClick={() => mainSlider.current.slickPrev()}><SliderPrevArrow /></button>
                                        <button className="next" onClick={() => mainSlider.current.slickNext()}><SliderNextArrow /></button>
                                        </div>
                                        <div className="on-booking d-flex">
                                        <Link to="#" onClick={openLighbox}><i className="icon-zoom-scr"></i></Link>
                                        </div>
                                    </div>
                                    <div className="slider-thumbnail-wrap d-none d-md-flex">
                                        <Slider {...thumbnailSettings} ref={thumbnailSlider} afterChange={
                                                v => afterChangeHandler(v)
                                            }>
                                        {props.property_images && props.property_images.map((img, index) => (
                                            <div key={index} className="thumbnail-block-col">
                                            {img?.hd_url ? <img src={img?.hd_url} alt={`${props.property_title} - Martyn Gerrard`} /> :
                                            <ImageRenderList
                                                imagesources={img}
                                                renderer="srcSet"
                                                imagename="property.images.thumbnail"
                                                attr={{ alt: `${props.property_title} - Martyn Gerrard`, class: '' }}
                                                imagetransformresult={props.processedImages}
                                                id={props.id}
                                            />}
                                            </div>
                                        ))}
                                        </Slider>
                                        <div className="thumb-navigation">
                                        <button className="prev" onClick={() => thumbnailSlider.current.slickPrev()}><SliderPrevArrow /></button>
                                        <button className="next" onClick={() => thumbnailSlider.current.slickNext()}><SliderNextArrow /></button>
                                        </div>
                                    </div>
                                        {/* <Slider {...settings}
                                            ref={slider}
                                            afterChange={
                                                v => afterChangeHandler(v)
                                            }
                                         >
                                            {
                                                props.property_images && props.property_images.map(img => {

                                                    const image_url = img.url

                                                    return <>
                                                        <div className="slider-block-col">
                                                            <ImageTransform imagesources={image_url} renderer="srcSet" imagename="property.images.detail" attr={{ alt: props.property_title + ' - Martyn Gerrard', class: '' }} imagetransformresult={props.processedImages} id={props.id} />
                                                        </div>
                                                    </>
                                                })
                                            }
                                            {props.property_images.length == 0 &&
                                                <img loading="lazy" src={NoImg} alt="" />
                                            }
                                        </Slider> */}
                                        <div className="property-status">
                                            {["Under Offer", "Let", "Sold"].includes(props.property_status) && (
                                                <div className={`property-badge badge-${props.property_status.replace(/\s+/g, '-').toLowerCase()}`}>
                                                    {props.property_status === "Under Offer" ? "Sold STC" : props.property_status}
                                                </div>
                                            )}
                                        </div>

                                       
                                        {/* {props.property_status === "For Sale" ? <i className="icon-property-badge"></i> : ''}
                                        {props.property_status === "Under Offer" ? <i className="icon-under-offer icon-property-badge"></i> : ''}
                                        {props.property_status === "Let" ? <i className="icon-details-let icon-property-badge"></i> : ''}
                                        {props.property_status === "Sold" ? <i className="icon-details-sold icon-property-badge"></i> : ''} */}
                                    </div>
                                    <div className="child-view d-flex">
                                        {props.property_images?.length > 1 ?
                                            <div className="img-wrap">
                                                {props.property_images[1].hd_url ? <img src={props.property_images[1].hd_url} alt={`${props.property_title} + ' - Martyn Gerrard`}/> :
                                                <ImageRenderList imagesources={props.property_images[1]} renderer="srcSet" imagename="property.images.tile_1" attr={{ alt: props.property_title + ' - Martyn Gerrard', class: '' }} imagetransformresult={props.processedImages} id={props.id} /> }

                                                {tile_one_url ?
                                                <>
                                                    <PropertyDetailsModal url={tile_one_url} title={props.address_details} />
                                                    <div className="tag-overlay">
                                                        <span>{tile_one_label}</span>
                                                    </div>
                                                    </>
                                                    : ''}
                                                
                                            </div>
                                            : ''}
                                            {props.property_images?.length > 2 ?
                                                <div className="img-wrap">
                                                    {props.property_images[2].hd_url ? <img src={props.property_images[2].hd_url} alt={`${props.property_title} + ' - Martyn Gerrard`}/> :
                                                    <ImageRenderList imagesources={props.property_images[2]} renderer="srcSet" imagename="property.images.tile_1" attr={{ alt: props.property_title + ' - Martyn Gerrard', class: '' }} imagetransformresult={props.processedImages} id={props.id} /> }

                                                    {tile_two_url ?
                                                        <>
                                                        <PropertyDetailsModal url={tile_two_url} title={props.address_details} />
                                                        <div className="tag-overlay">
                                                            <span>Video</span>
                                                        </div>
                                                        </>
                                                        : ''}
                                                </div>
                                                : ''}

                                    </div>
                                    <FsLightbox
                                        toggler={lightboxController.toggler}

                                        sources={lightImages2}
                                        type='image'
                                        key={lightboxController.key}

                                    />
                                </motion.div>
                                : ''
                        }
                        <motion.div
                            className="booking-details text-center order-xl-1"
                            variants={containerItemText}
                        >
                            <a href="javascript:void(0)" onClick={handleBack} className="back-to text-uppercase"> &lt; Back to search results</a>
                            {props.property_price ? (
                                <div className="sec-title price-title">
                                {
                                   props.price_qualifier === "POA" ? "POA" : <><span className="price_qua_price">£{props.property_price.toLocaleString()}</span> <span class="price_qualifier">{props.price_qualifier}</span></>
                                }

                                {/* {props.price_qualifier !== "Price on Application" && (
                                    <span className="price_qua_price">
                                    £{props.property_price.toLocaleString()}
                                    </span>
                                )}{" "} */}

                                {props.tag == "new-homes"
                                    ? props.property_max_price
                                    ? "- £" + props.property_max_price.toLocaleString()
                                    : ""
                                    : ""}
                                
                                {/* {props.price_qualifier && (
                                <span class="price_qualifier">{props.price_qualifier} </span>
                                )} */}
                                {/* {props.price_qualifier && 
                                props.price_qualifier
                                } */}
                                {/* {props.property_search_type === "lettings" ? "pcm" : ""} */}
                                </div>
                            ) : (
                                ""
                            )}                            {
                            props.address_details ? <h1 className="add-txt d-block">{props.address_details}
                                {props.property_maxbedroom ?
                                    <p className="sale-txt">{props.property_bedroom + ' - ' + props.property_maxbedroom + ' bedrooms available'}</p>
                                    :
                                    props.property_title ? <p className="sale-txt">
                                    <span dangerouslySetInnerHTML={{ __html: props.property_title.replace(/(.*?)(for sale)/i, (match, p1, p2) => 
                                      `<span class="text-uppercase">${p1.trim()}</span> <span class="text-normal">${p2}</span>`
                                    ) }} />
                                  </p>: ''
                                }</h1> : ''}
                            {/* { props.property_title ? <p className="sale-txt">{props.property_title}</p> : '' } */}
                            {
                                props.tag == "new-homes" ? '' :
                                    <>
                                        <ul className="plan-list first-row">
                                            {props.property_bedroom ?
                                                <li>
                                                    <i className="icon-bedroom"></i>
                                                    <span className="desc d-block">{props.property_bedroom} Bedrooms</span>
                                                </li>
                                                : ''}
                                            {props.property_bathroom ?
                                                <li>
                                                    <i className="icon-bathroom"></i>
                                                    <span className="desc d-block">{props.property_bathroom} Bathrooms</span>
                                                </li>
                                                : ''}
                                            {props.property_building ?
                                                props.property_building == "house" || props.property_building == "apartment" || props.property_building == "Apartment" ?
                                                    <li>
                                                        <i className="icon-house-apartment"></i>
                                                        <span className="desc d-block apartment-text-element">{props.property_building}</span>
                                                    </li>
                                                    :
                                                    props.property_building == "Flat" ?
                                                        <li>
                                                            <i className="icon-office"></i>
                                                            <span className="desc d-block">Apartment</span>
                                                        </li>
                                                        :
                                                    props.property_building == "office" ?
                                                        <li>
                                                            <i className="icon-office"></i>
                                                            <span className="desc d-block">Office</span>
                                                        </li>
                                                        :
                                                        props.property_building == "industrial" ?
                                                            <li>
                                                                <i className="icon-industry"></i>
                                                                <span className="desc d-block">Industrial</span>
                                                            </li>
                                                            :
                                                            props.property_building == "retail" ?
                                                                <li>
                                                                    <i className="icon-retail"></i>
                                                                    <span className="desc d-block">Retail</span>
                                                                </li>
                                                                : ''
                                                : ''
                                            }
                                            {props.property_parking ?
                                                props.property_parking == "Garage" ?
                                                    <li>
                                                        <i className="icon-garage"></i>
                                                        <span className="desc d-block">Parking</span>
                                                    </li>
                                                    :
                                                    ''
                                                : ''
                                            }
                                            {virtual_tour_url ?
                                                <PropertyDetailsModalIconVideo url={virtual_tour_url} title={props.address_details} />
                                                : ''}
                                            {/* </ul>

                                    <ul className="plan-list second-row"> */}
                                            {props.property_floorplan ?
                                                props.property_floorplan.length > 0 ?
                                                    <li>
                                                         <FloorPlanModalDetails icon={"floorplan"} processedImagesFloorplan={props.processedImagesFloorplan} floorplanimg={props.property_floorplan[0]?.hd_url || props.property_floorplan[0]?.url} floorplanimg_src={props.property_floorplan[0].srcUrl} />
                                                    </li>
                                                    : ''
                                                : ''
                                            }
                                             {props.property_epc ?
                                                props.property_epc.length > 0 ?
                                                    <li>
                                                        <FloorPlanModalDetails icon={"epc"} processedImagesFloorplan={props.processedImagesFloorplan} floorplanimg={props.property_epc[0]?.hd_url || props.property_epc[0].url} />
                                                    </li>
                                                    : ''
                                                : ''
                                            }
                                            <li>
                                                <a href="javascript:void(0)" className="desc link d-block mapTransportTransport">
                                                    <i className="icon-tube"></i>
                                                    <div>Transport</div>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)" className="desc link d-block mapTransportSchool">
                                                    <i className="icon-schools-blue"></i>
                                                    <div>Schools</div>
                                                </a>
                                            </li>
                                            {keywords && (<li><i className="icon-no-deposit-option"></i><span className="desc d-block">No Deposit Option</span></li>)}
                                            <li className="d-xl-none d-inline-block w-100">
                                                <div className="share-print share-print-mobile">
                                                    <SaveProperty type="property" pid={props.id} />
                                                    <a href="javascript:void(0)" onClick={openShareicons} className="share-mobile"><i className="icon-share"></i>Share
                                                        {Shareicons &&
                                                            <SocialShare openShareicons={openShareicons} openBookViewformModal={openBookViewformModal} className="mobile-details-socila-share" />
                                                        }
                                                    </a>
                                                    {props.brochure && props.brochure.length != 0 ?
                                                        <a href={props.brochure[0].srcUrl} target="_blank"><i className="icon-print"></i>Print</a> : ''}
                                                </div>
                                            </li>
                                        </ul>
                                    </>
                            }
                            <div className="btns-wrap d-none d-xl-block">
                                <Link to="#" className="btn" onClick={openSendfrndformModal} >book a viewing</Link>
                                <Link to="#" className="btn btn-success" onClick={openAskformModal} >ask a question</Link>
                                <Link to="/market-your-property/book-a-valuation/" className="btn btn-success">value my home</Link>
                                <div className="share-print">
                                    <SaveProperty type="property" pid={props.id} />
                                    <a href="javascript:void(0)" onClick={openShareicons}><i className="icon-share"></i>Share
                                        {Shareicons &&
                                            <SocialShare openShareicons={openShareicons} openBookViewformModal={openBookViewformModal} />
                                        }
                                    </a>

                                    {props.brochure && props.brochure.length != 0 ?
                                        <a href={props.brochure[0].srcUrl} target="_blank"><i className="icon-print"></i>Print</a> : ''}
                                </div>
                            </div>

                            {props.negotiator_details &&
                                <Negotiator data={props.negotiator_details} office_id={props?.office_id} />
                            }

                        </motion.div>
                    </motion.section>

                    {
                        props.tag == "new-homes" ?
                            <section className="property_new_sticky d-flex align-items-center">
                                <Container>
                                    <Row>
                                        <Col>
                                            <div className="d-flex justify-content-between">
                                                <ul className="list-inline d-flex align-items-center property-newhomes-menu">
                                                    <li className="list-inline-item"><a href="javascript:void(0)" className="details_features active">Details & Features</a></li>

                                                    <li className="list-inline-item main-availability-menu"><a href="javascript:void(0)" className="availability">Availability</a></li>

                                                    {general_video_url &&
                                                        <li className="list-inline-item"><a href={general_video_url} target="_blank" className="new_homes_video_link">Video</a></li>
                                                    }

                                                    <li className="list-inline-item"><a href="javascript:void(0)" className="location">Location</a></li>


                                                    {props.property_floorplan ?
                                                        (props.property_floorplan.length > 0 && props.property_floorplan[0].url ?
                                                            <li>
                                                                <FloorPlanModalDetailsNewHomes processedImagesFloorplan={props.processedImagesFloorplan} floorplanimg={props.property_floorplan[0].hd_url || props.property_floorplan[0].url} />
                                                            </li>
                                                            : '')
                                                        : ''
                                                    }

                                                    {props.brochure?.length != 0 &&
                                                        <li className="list-inline-item"><a href={props.brochure[0]} target="_blank" className="new_homes_video_link">Brochure</a></li>
                                                    }


                                                    <li className="list-inline-item">
                                                        <a href="javascript:void(0)" className="property-newhomes-icon new-homes-share" onClick={openShareicons} ><i className="icon-share"></i>
                                                            {Shareicons &&
                                                                <SocialShare openShareicons={openShareicons} openBookViewformModal={openBookViewformModal} className="new-homes-share-icons" />
                                                            }
                                                        </a>
                                                    </li>
                                                    {/* <li className="list-inline-item"><a href="javascript:void(0)" className="property-newhomes-icon"><i className="icon-print"></i></a></li> */}
                                                </ul>
                                                <div className="d-flex align-items-center property_booking_btn">
                                                    <a href="javascript:void(0)" className="btn" onClick={openSendfrndformModal}>Book a Viewing</a>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Container>
                            </section>
                            : ""
                    }


                    <ModalTiny backdrop="static" show={modalBookViewformOpen} onHide={closeBookViewformModal} className="book-a-viewing-modal share-to-friend-modal">
                        <ModalTiny.Header closeButton className="contact-close-btn">
                            <ModalTiny.Title className="w-100"><h2 className="text-center mb-0 text-uppercase">SHARE TO A FRIEND</h2></ModalTiny.Title>
                        </ModalTiny.Header>
                        <ModalTiny.Body className="event-section"><SendForm office_id={props.office_id} office_email={office_email} office_usearea_email={office_usearea_email} property_img={img_1} page_url={shareurl} property_title={props.address_details} negotiator={props.crm_negotiator_id ? props.crm_negotiator_id : ''} /></ModalTiny.Body>
                    </ModalTiny>

                    <ModalTiny backdrop="static" show={modalSendfrndformOpen} onHide={closeSendfrndformModal} className="book-a-viewing-modal">
                        <ModalTiny.Header closeButton className="contact-close-btn">
                            <ModalTiny.Title className="w-100"><h2 className="text-center mb-0 text-uppercase">Book a Viewing</h2></ModalTiny.Title>
                        </ModalTiny.Header>
                        <ModalTiny.Body className="event-section"><Form office_id={props.office_id} type={props.property_search_type} crm_id={props.crm_id} office_email={negotiatorEmail} office_usearea_email={office_usearea_email} property_img={img_1} price={props.property_price} page_url={shareurl} property_title={props.address_details} negotiator={props.crm_negotiator_id ? props.crm_negotiator_id : ''} /></ModalTiny.Body>
                    </ModalTiny>

                    <ModalTiny backdrop="static" show={modalAskformOpen} onHide={closeAskformModal} className="book-a-viewing-modal">
                        <ModalTiny.Header closeButton className="contact-close-btn">
                            <ModalTiny.Title className="w-100"><h2 className="text-center mb-0 text-uppercase">Ask a Question</h2></ModalTiny.Title>
                        </ModalTiny.Header>
                        <ModalTiny.Body className="event-section"><AskForm office_id={props.office_id} type={props.property_search_type} crm_id={props.crm_id} office_email={officeEmail} office_usearea_email={office_usearea_email} property_img={img_1} price={props.property_price} page_url={shareurl} property_title={props.address_details} negotiator={props.crm_negotiator_id ? props.crm_negotiator_id : ''} /></ModalTiny.Body>
                    </ModalTiny>

                    <section className="fixed-btns d-flex d-xl-none d-lg-flex">
                        <Link to="#" className="btn book-btn" onClick={openSendfrndformModal}>book a viewing</Link>
                        <Link to="/market-your-property/book-a-valuation/" className="btn ask-btn btn-success d-md-block">value my home</Link>
                        <Link to="#" className="btn book-btn d-none d-md-block" onClick={openAskformModal}>ask a question</Link>
                    </section>
                </>
            )}
        </InView>
    )
}

export default Booking
